import { IPromo } from '../../../types/promosPage';
import { MAX_PROMOS_PER_SCREEN } from '../constants';

export const getDescription = (promo: IPromo, promosCount: number): string | undefined =>
  promosCount >= MAX_PROMOS_PER_SCREEN ? undefined : promo.description;
